import { render } from "./ImageCropperDialog.vue?vue&type=template&id=59877ef0"
import script from "./ImageCropperDialog.vue?vue&type=script&lang=js"
export * from "./ImageCropperDialog.vue?vue&type=script&lang=js"

import "./ImageCropperDialog.vue?vue&type=style&index=0&id=59877ef0&lang=css"
script.render = render

export default script